// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwCommandPanelSection from 'viewmodel/AwCommandPanelSectionViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwI18n from 'viewmodel/AwI18nViewModel';
import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesTeamMembersService', () => import('js/DesTeamMembersService'));
registerDynImportEntry('js/desCollabEventBus', () => import('js/desCollabEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "props": {
    "sub-panel-context": {
      "type": "object"
    },
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "containerId": {
      "type": "string"
    },
    "email-template-id": {
      "type": "string"
    },
    "email-template-params": {
      "type": "string"
    }
  },
  "data": {
    "teamName": {
      "displayName": "{{i18n.teamName}}",
      "type": "STRING",
      "isRequired": "true",
      "isEditable": "true",
      "dbValue": "",
      "dispValue": "",
      "requiredText": "{{i18n.requiredNoSpaceString}}"
    },
    "teamDescription": {
      "displayName": "{{i18n.teamDescription}}",
      "type": "STRING",
      "isRequired": "true",
      "isEditable": "true",
      "dbValue": "",
      "dispValue": "",
      "requiredText": "{{i18n.requiredString}}"
    },
    "message": {
      "displayName": "{{i18n.message}}",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "requiredText": "{{i18n.emailMessageString}}"
    },
    "commands": "aw_addTeamMemberCommandAnchor",
    "filteredObj": [],
    "filteredMembers": [],
    "membersListOnMainPanel": []
  },
  "actions": {
    "reveal": {
      "actionType": "dataProvider",
      "method": "assignedTeamMembersProvider"
    },
    "performBatchActionOnCreateTeam": {
      "actionType": "batchJob",
      "steps": [{
        "action": "publishToACCEventBus",
        "inputData": {
          "eventId": "{{parameters.eventName}}",
          "eventData": "{{parameters.eventData}}"
        }
      }, {
        "action": "addMembers",
        "condition": "data.memberObj.length>0",
        "inputData": {
          "eventId": "{{eventName.eventName}}",
          "eventData": "{{eventData.eventData}}"
        }
      }]
    },
    "createTeam": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "additionalProperties": {
              "collaborationspaceid": "{{props.collaborationspaceid}}"
            },
            "query": "mutation CreateTeam( $createTeamInput: CreateTeamInput) { createTeam( createTeamInput: $createTeamInput )}",
            "variables": {
              "createTeamInput": {
                "teamDescription": "{{data.teamDescription.dbValue}}",
                "teamName": "{{data.teamName.dbValue}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "catalog",
        "accsessionid": "{{props.accsessionid}}"
      },
      "outputData": {
        "createdTeam": "data.data.createTeam",
        "teamID": "data.data.createTeam.teamId",
        "output": "data.data.createTeam.output"
      },
      "events": {
        "failure": [{
          "name": "desCreateTeamFailure",
          "eventData": {
            "eventName": "desCreateTeamFailure",
            "eventData": "{{createdTeam}}"
          }
        }],
        "success": [{
          "name": "desCreateTeamSuccess",
          "eventData": {
            "eventName": "desCreateTeamSuccess",
            "eventData": "{{createdTeam}}"
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "addMembers": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "additionalProperties": {
              "collaborationspaceid": "{{props.collaborationspaceid}}",
              "assignedTeamMembers": "{{data.memberObj}}",
              "teamId": "{{data.teamID}}"
            },
            "query": "mutation AddTeamMembers( $addTeamMembersInput: Json) {addTeamMembers( addTeamMembersInput: $addTeamMembersInput )}",
            "variables": {
              "addTeamMembersInput": {
                "addTeamMembersInput": {}
              }
            }
          }
        },
        "progressIndicatorPrefix": "catalog",
        "accsessionid": "{{props.accsessionid}}"
      },
      "outputData": {
        "addedTeamMembers": "data.data.addTeamMembers"
      },
      "events": {
        "failure": [{
          "name": "addTeamMembers.failure",
          "eventData": {
            "eventName": "desCreateTeamFailure",
            "eventData": "{{addedTeamMembers}}"
          }
        }],
        "success": [{
          "name": "addTeamMembers.success",
          "condition": "createdTeam.hasError === false",
          "eventData": {
            "eventName": "desCreateTeamSuccess",
            "eventData": "{{addedTeamMembers}}"
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "performBatchActionOnNavigation": {
      "actionType": "batchJob",
      "steps": [{
        "action": "resetArrays"
      }, {
        "action": "navigateAction"
      }]
    },
    "navigateAction": {
      "actionType": "JSFunction",
      "method": "switchPanel",
      "inputData": {
        "commandContext": "{{props.subPanelContext.sharedData}}",
        "panelView": "createTeamSubPanel"
      },
      "deps": "js/DesTeamMembersService"
    },
    "resetArrays": {
      "actionType": "JSFunction",
      "method": "resetArrays",
      "inputData": {
        "vmo": "{{data}}"
      },
      "deps": "js/DesTeamMembersService"
    },
    "removeTeamMembers": {
      "actionType": "JSFunctionAsync",
      "method": "removeTeamMembers",
      "inputData": {
        "commandContext": "{{commandContext.vmo}}",
        "membersToRemove": "{{data.memberObj}}",
        "vmo": "{{data}}"
      },
      "outputData": {
        "filteredObjArray": "filteredObj",
        "filteredMembersArray": "filteredMembers"
      },
      "events": {
        "failure": [{
          "name": "removeTeamMembersFailure",
          "eventData": {
            "eventName": "removeTeamMembersFailure",
            "eventData": "{{filteredObjArray}}"
          }
        }],
        "success": [{
          "name": "removeTeamMembersSuccess",
          "eventData": {
            "eventName": "removeTeamMembersSuccess",
            "eventData": "{{filteredObjArray}}"
          }
        }]
      },
      "deps": "js/DesTeamMembersService"
    },
    "getAssignedTeamMembers": {
      "actionType": "JSFunction",
      "method": "getAssignedTeamMembers",
      "inputData": {
        "sharedData": "{{props.subPanelContext.sharedData}}",
        "listTeamMembers": "",
        "membersAfterRemovalAction": "{{data.filteredObj}}",
        "filteredMembersAfterRemoval": "{{data.filteredMembers}}",
        "vmo": "{{data}}"
      },
      "outputData": {
        "memberObj": "membersListOnMainPanel",
        "totalAssignedTeamMembers": "totalAssignedTeamMembers"
      },
      "events": {
        "success": [{
          "name": "getAssignedTeamMembers.success",
          "eventData": {
            "eventName": "getAssignedTeamMembers.success",
            "eventData": "{{memberObj}}"
          }
        }]
      },
      "deps": "js/DesTeamMembersService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventName}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/desCollabEventBus"
    }
  },
  "dataProviders": {
    "assignedTeamMembersProvider": {
      "action": "getAssignedTeamMembers",
      "response": "{{data.memberObj}}",
      "totalFound": "{{data.totalAssignedTeamMembers}}",
      "commandsAnchor": "des_removeTeamMemberCommandAnchor"
    }
  },
  "conditions": {
    "enableCreateTeamButton": {
      "expression": "data.teamName.dbValue && data.teamDescription.dbValue"
    }
  },
  "onEvent": [{
    "eventId": "awPanel.navigate",
    "action": "performBatchActionOnNavigation"
  }, {
    "eventId": "storeData.success",
    "action": "reveal"
  }, {
    "eventId": "removeTeamMembersSuccess",
    "action": "reveal"
  }, {
    "eventId": "desCreateTeamSuccess",
    "action": "performBatchActionOnCreateTeam",
    "inputArgs": {
      "eventName": "desCreateTeamSuccess",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "removeTeamMemberAction",
    "action": "removeTeamMembers",
    "inputArgs": {
      "eventName": "removeTeamMemberAction",
      "eventData": "{{eventData.eventData}}"
    }
  }],
  "messages": {
    "sucessResetMesssage": {
      "messageType": "INFO",
      "messageText": "Form is reset to default values"
    }
  },
  "i18n": {
    "commandPanelDemo": ["DesTeamMessages"],
    "teamName": ["DesTeamMessages"],
    "teamDescription": ["DesTeamMessages"],
    "message": ["DesTeamMessages"],
    "createButton": ["DesTeamMessages"],
    "commandPanelCreateTeam": ["DesTeamMessages"],
    "submitButtonTitle": ["TCUICommandPanelsMessages"],
    "teamMembers": ["DesTeamMessages"],
    "requiredNoSpaceString": ["DesTeamMessages"],
    "requiredString": ["DesTeamMessages"],
    "emailMessageString": ["DesTeamMessages"]
  },
  "_viewModelId": "DesCreateTeamMainPanel",
  "_uniqueViewModelId": "DesCreateTeamMainPanel",
  "ctx": {}
};

/*
<aw-panel>
    <aw-textbox prop="data.teamName"></aw-textbox>
    <aw-textbox prop="data.teamDescription"></aw-textbox>
    <aw-textbox prop="data.message"></aw-textbox>
    <aw-panel-body>
        <aw-command-panel-section caption="i18n.teamMembers"
            sub-panel-context='{sharedData: props.subPanelContext.sharedData}' anchor="data.commands">
            <aw-list dataprovider='data.dataProviders.assignedTeamMembersProvider'>
                <aw-default-cell vmo='item'></aw-default-cell>
            </aw-list>
        </aw-command-panel-section>
    </aw-panel-body>
    <aw-panel-footer>
        <aw-button size='stretched' enable-when="conditions.enableCreateTeamButton" action="createTeam">
            <aw-i18n>{{i18n.createButton}}</aw-i18n>
        </aw-button>
    </aw-panel-footer>
</aw-panel>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal
  }, /*#__PURE__*/React.createElement(AwTextbox, getField("data.teamName", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwTextbox, getField("data.teamDescription", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwTextbox, getField("data.message", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwPanelBody, null, /*#__PURE__*/React.createElement(AwCommandPanelSection, {
    caption: i18n.teamMembers,
    "sub-panel-context": "{sharedData: props.subPanelContext.sharedData}",
    anchor: AwParseService.instance("data.commands")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwList, {
    dataprovider: dataProviders.assignedTeamMembersProvider,
    showDropArea: null,
    dndHandler: props.viewModel.dndHandler
  }, ({
    item,
    index
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "                    ", /*#__PURE__*/React.createElement(AwDefaultCell, {
      vmo: AwParseService.instance("item")({
        props,
        data,
        fields,
        dataProviders,
        ctx,
        i18n,
        actions,
        subPanelContext,
        viewPath,
        conditions,
        formProp,
        dispatch,
        selectionModels,
        editHandlers,
        chartProviders,
        ports,
        item,
        index
      })
    }));
  }))), /*#__PURE__*/React.createElement(AwPanelFooter, null, /*#__PURE__*/React.createElement(AwButtonEnableWhen, {
    size: "stretched",
    action: actions.createTeam,
    enableWhen: AwParseService.instance("conditions.enableCreateTeamButton")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwI18n, null, AwParseService.instance("i18n.createButton")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;